import { ResourceBaseService } from "@/core/common/resource-base/resource-base.service";
import { ApiHttpClient } from "@/core/common/http/api-http-client";
import { PointConfigurationDto } from "@/core/features/point-configurations/point-configuration.dto";
import { CreatePointConfigurationDto } from "@/core/features/point-configurations/create-point-configuration.dto";
import { UpdatePointConfigurationDto } from "@/core/features/point-configurations/update-point-configuration.dto";

export class PointConfigurationsResource extends ResourceBaseService<
  PointConfigurationDto,
  CreatePointConfigurationDto,
  UpdatePointConfigurationDto
> {
  protected EntityDto = PointConfigurationDto;
  protected CreateEntityDto = CreatePointConfigurationDto;
  protected UpdateEntityDto = UpdatePointConfigurationDto;

  constructor(protected readonly apiHttpClient: ApiHttpClient) {
    super(apiHttpClient, "/point-configurations");
  }
}
